export default {
    quiz: {},
    quizQuestions: [],
    noAnswerQuestion: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/quiz/state.js